import React from 'react';
import PropTypes from 'prop-types';

import Link from './link';
import Image from './image';

const ArtistTile = ({ title, slug, image }) => (
  <Link href="/artists/[slug]" as={`/artists/${slug}`} className="block group">
    <div className="aspect-ratio-square relative bg-black shadow-lg">
      <Image
        src={image}
        alt={title}
        width={600}
        height={600}
        auto={['format', 'compress', 'enhance']}
        fit="crop"
        crop="faces"
        className="block absolute inset-0 object-cover object-center w-full h-full group-hover:opacity-25 transition-opacity duration-500"
      />
    </div>
    <h2 className="font-display uppercase text-2xl font-bold text-white group-hover:text-gray-base transition-colors duration-500 mt-4">
      {title}
    </h2>
  </Link>
);

ArtistTile.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
};

export default ArtistTile;
